/* ISD quick add — one delegated handler for every [data-isd-add] button
   (product cards in tabs, related products, collection grid, box add-ons).
   Loaded once; safe with Theme Editor re-renders because it uses delegation. */
(function () {
  if (window.__isdQuickAddBound) return;
  window.__isdQuickAddBound = true;

  var TEXT = Object.assign({ adding: 'Pridedama…', added: 'Pridėta', error: 'Nepavyko pridėti. Bandykite dar kartą.' }, (window.ISD && window.ISD.ui) || {});

  function label(btn) { return btn.querySelector('.isd-card__add-label, [data-isd-add-label]'); }

  function setLabel(btn, text) {
    var el = label(btn);
    if (el) el.textContent = text;
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-isd-add]');
    if (!btn || btn.disabled || btn.classList.contains('is-loading')) return;
    event.preventDefault();
    event.stopPropagation();
    if (!window.ISD || !window.ISD.cart) { window.location.href = btn.getAttribute('data-isd-href') || '/cart'; return; }

    var id = btn.getAttribute('data-isd-add');
    var select = btn.getAttribute('data-isd-select');
    if (select) {
      var sel = document.getElementById(select);
      if (sel && sel.value) id = sel.value;
    }
    var qty = Number(btn.getAttribute('data-isd-qty') || 1);
    var original = btn.getAttribute('data-label-default') || (label(btn) ? label(btn).textContent : '');
    var openDrawer = btn.getAttribute('data-isd-open') !== 'false';

    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    setLabel(btn, TEXT.adding);

    window.ISD.cart.add(id, qty).then(function () {
      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      setLabel(btn, TEXT.added);
      if (openDrawer) window.ISD.cart.open();
      window.setTimeout(function () { btn.classList.remove('is-added'); setLabel(btn, original); }, 1400);
    }).catch(function (err) {
      console.warn('[ISD] quick add failed', err);
      btn.classList.remove('is-loading');
      btn.classList.add('is-error');
      setLabel(btn, TEXT.error);
      window.setTimeout(function () { btn.classList.remove('is-error'); setLabel(btn, original); }, 2200);
    }).finally(function () {
      btn.removeAttribute('aria-busy');
    });
  }, true);
})();
